import React, { useState, useEffect, useMemo, Fragment } from "react";
import { useParams } from "react-router";
import { connect } from "react-redux";
import Loading from "components/Loading";
import { getInfluencerDetail } from "actions/spyAdvancedActions";
import useCallApi from "hook/useCallApi";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import cx from "classnames";
import { Overview, Followers, Distributionofproductcategories, Productrecord } from "./detail_tabs";
import { getQueryParams, FlagRegionByIso } from "components/Function";

const InfluencerDetail = ({ getInfluencerDetail }) => {
    const { filter: initialFilter } = getQueryParams();
    const [filter, setFilter] = useState(initialFilter);
    const { t } = useTranslation();
    const [tab, setTab] = useState("basic");
    const { influencer_id } = useParams();
    const params = useMemo(() => ({ ...filter, influencer_id }), [filter, influencer_id]);
    const { data, loading } = useCallApi(getInfluencerDetail, params);
    const { detail, overview, sale_overview, follower_trending, digg_trending, video_overview, live_overview, follower_profile, products_analysis, products_filters } = data || {};
    
    useEffect(() => {
        const params = new URLSearchParams({ ...filter });
        window.history.replaceState({}, "", `${window.location.pathname}?${params.toString()}`);
    }, [filter]);

    const onClick = (data) => {
        setTab(data);
    };

    return (
        <Fragment>
            <Loading isLoading={loading} />
            <div className="card">
                <div className="card-body">
                    <div className="d-flex flex-wrap flex-sm-nowrap align-items-center">
                        <div className="me-7 mb-4">
                            <div className="symbol symbol-100px symbol-circle symbol-lg-120px symbol-fixed position-relative">
                                <img src={detail?.avatar_url || require("components/assets/media/misc/image.png")} alt=""/>
                            </div>
                        </div>
                        <div className="flex-grow-1">
                            <div className="d-flex justify-content-between align-items-start flex-wrap mb-2">
                                <div className="d-flex flex-column">
                                    <div className="d-flex align-items-center">
                                        <Link to="#" className="text-gray-900 text-hover-primary fs-2 fw-bold me-1">{detail?.influencer_name}</Link>
                                        <button className="btn btn-link text-hover-primary me-10" data-tooltip-id="my-tooltip"
                                            data-tooltip-content={"Copy"}
                                            onClick={() => navigator.clipboard.writeText(detail?.influencer_name)}
                                        >
                                            <i className="ki-duotone ki-copy">
                                            </i>
                                        </button>
                                        { detail?.show_case && <img src={require("components/assets/media/misc/showcase.png")} alt="" width="25" height="25" data-tooltip-id="my-tooltip" data-tooltip-content={"The influencer has activated their showcase."} />}
                                        { detail?.sales_flag > 0 && <img src={require("components/assets/media/misc/sellproduct.png")} alt="" width="25" height="25" data-tooltip-id="my-tooltip" data-tooltip-content={"The influencer can sell products."} />}
                                        { detail?.total_live_cnt > 0 && <img src={require("components/assets/media/misc/livestream.png")} alt="" width="25" height="25" data-tooltip-id="my-tooltip" data-tooltip-content={"The influencer has live-streamed before."} />}
                                    </div>
                                    <div className="d-flex align-items-center gap-2 flex-wrap">
                                        {t("Tiktok ID")}: <Link to={"https://www.tiktok.com/@" + detail?.unique_id} className="text-info me-1" target="_blank">@{detail?.unique_id}</Link>
                                        <button className="btn btn-link text-hover-primary" data-tooltip-id="my-tooltip"
                                            data-tooltip-content={"Copy"}
                                            onClick={() => navigator.clipboard.writeText(detail?.unique_id)}
                                        >
                                            <i className="ki-duotone ki-copy">
                                            </i>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row bg-light-info al-border-radius-8 p-5 mb-4 mx-0">
                        <div className="col-lg-12 mb-7">
                            <span className="me-1 text-gray-500">{t("BIO")}:</span>
                            <span className="me-1">{detail?.bio}</span>
                            <i className="fa fa-link"></i><Link to={detail?.bio_link} className="text-info me-1" target="_blank">{detail?.bio_link}</Link>
                        </div>
                        <div className="col-lg-12 mb-7">
                            <span className="me-1 text-gray-500">{t("Description")}:</span>
                            <span className="me-1">
                                {`${detail?.influencer_name} (@${detail?.unique_id}) is a ${detail?.influencer_level} influencer from the United States who posts videos, live streams, and sells goods on TikTok`}
                                { Object.keys(detail?.social_media_accounts || {}).length > 0 && `@${detail?.unique_id}'s social media accounts:` }
                                {
                                    Object.entries(detail?.social_media_accounts || {}).map(([k, v]) => (
                                        <Fragment>
                                            <br/>
                                            <span className="me-2">
                                                <img src={require(`components/assets/media/misc/${k}.png`)} alt="" width="25" height="25" className="me-1" />
                                                <span className="text-capitalize me-1">{k}:</span>
                                                <Link to={v?.url} className="text-info me-1" target="_blank">{v?.id}</Link>
                                            </span>
                                            <button className="btn btn-link text-hover-primary" data-tooltip-id="my-tooltip"
                                                data-tooltip-content={"Copy"}
                                                onClick={() => navigator.clipboard.writeText(v?.id)}
                                            >
                                                <i className="ki-duotone ki-copy">
                                                </i>
                                            </button>
                                        </Fragment>
                                    ))
                                }
                            </span>
                        </div>
                        <div className="d-flex flex-wrap justify-content-between w-100">
                            <div className="d-flex">
                                <span className="text-gray-500 me-1">{t("Region")}:</span>
                                <FlagRegionByIso name={detail?.region?.name} iso={detail?.region?.key} />
                            </div>
                            <div className="d-flex">
                                <span className="text-gray-500 me-1">{t("Certificate")}:</span>
                                <span data-tooltip-id="my-tooltip" data-tooltip-content={detail?.certificate?.info}>
                                    <i className={cx("fa fa-id-card-o", { "text-dark": +detail?.certificate?.type === 0, "text-success": +detail?.certificate?.type === 1, "text-info": +detail?.certificate?.type === 2 })}></i>
                                </span>
                            </div>
                            <div className="d-flex">
                                <span className="text-gray-500 me-1">{t("Account Category")}:</span>
                                <span>
                                    {detail?.category}
                                </span>
                            </div>
                            <div className="d-flex">
                                <span className="text-gray-500 me-1">{t("Product Category")}:</span>
                                <span>
                                    {detail?.product_category ? detail?.product_category : t("No category yet.")}
                                </span>
                            </div>
                            {detail?.email && <div className="d-flex">
                                <span className="text-gray-500 me-1">{t("Email")}:</span>
                                <span className="text-danger">
                                    {detail?.email}
                                </span>
                                <button className="btn btn-link text-hover-primary p-0 ms-1" data-tooltip-id="my-tooltip"
                                    data-tooltip-content={"Copy"}
                                    onClick={() => navigator.clipboard.writeText(detail?.email)}
                                >
                                    <i className="ki-duotone ki-copy">
                                    </i>
                                </button>
                            </div>}
                        </div>
                    </div>
                    <div className="d-flex flex-wrap w-100 gap-3 justify-content-between">
                        <div className="d-flex">
                            <div className="bg-light-info al-border-radius-8 min-w-200px py-3 px-4 me-6 mb-3 h-100 d-flex flex-column">
                                <i className="ki-outline ki-like fs-3 text-info me-2 mb-2 py-5"></i><br />
                                <div className="fs-2 fw-bold counted">{detail?.score}</div>
                                <div className="fw-semibold fs-4">{t("Echo Score")}</div>
                                <div className="fs-8 text-gray-500">{t("ER Rate")}: {detail?.engagement_rate}</div>
                            </div>
                        </div>
                        <div className="d-flex">
                            <div className="bg-light-info al-border-radius-8 min-w-200px py-3 px-4 me-6 mb-3 h-100 d-flex flex-column">
                                <i className="fa fa-bullseye fs-3 text-info me-2 mb-2 py-5"></i><br />
                                <div className="fs-2 fw-bold counted">{detail?.followers_count}</div>
                                <div className="fw-semibold fs-4">{t("Followers")}</div>
                                <div className="fs-8 text-gray-500">{detail?.influencer_level}</div>
                            </div>
                        </div>
                        <div className="d-flex">
                            <div className="bg-light-info al-border-radius-8 min-w-200px py-3 px-4 me-6 mb-3 h-100 d-flex flex-column">
                                <i className="ki-outline ki-heart fs-3 text-info me-2 mb-2 py-5"></i><br />
                                <div className="fs-2 fw-bold counted">{detail?.likes_count}</div>
                                <div className="fw-semibold fs-4">{t("Likes")}</div>
                                <div className="fs-8 text-gray-500">{t("Likes/Followers")}: {detail?.likes_per_followers}</div>
                            </div>
                        </div>
                        <div className="d-flex">
                            <div className="bg-light-info al-border-radius-8 min-w-200px py-3 px-4 me-6 mb-3 h-100 d-flex flex-column">
                                <i className="ki-outline ki-to-right fs-3 text-info me-2 mb-2 py-5"></i><br />
                                <div className="fs-2 fw-bold counted">{detail?.videos_count}</div>
                                <div className="fw-semibold fs-4">{t("Videos")}</div>
                                <div className="fs-8 text-gray-500">{t("Average")} {detail?.views_per_video} {t("views")}</div>
                            </div>
                        </div>
                        <div className="d-flex">
                            <div className="bg-light-info al-border-radius-8 min-w-200px py-3 px-4 me-6 mb-3 h-100 d-flex flex-column">
                                <i className="ki-outline ki-wifi-home fs-3 text-info me-2 mb-2 py-5"></i><br />
                                <div className="fs-2 fw-bold counted">{detail?.total_live_cnt}</div>
                                <div className="fw-semibold fs-4">{t("LiveStreams")}</div>
                                <div className="fs-8 text-gray-500">{t("Average")} {detail?.per_live_user_avg_cnt} {t("views")}</div>
                            </div>
                        </div>
                        <div className="d-flex">
                            <div className="bg-light-info al-border-radius-8 min-w-200px py-3 px-4 mb-3 h-100 d-flex flex-column">
                                <i className="ki-outline ki-cup fs-3 text-info me-2 mb-2 py-5"></i><br />
                                <div className="fs-2 fw-bold counted">{detail?.total_product_cnt}</div>
                                <div className="fw-semibold fs-4">{t("Total Products")}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="">
                <div className="card-body pt-0 pb-0">
                    <ul className="nav nav-stretch nav-line-tabs nav-line-tabs-2x border-transparent fs-5 fw-bold">
                        <li className="nav-item mt-2">
                            <Link className={cx("nav-link text-active-primary ms-0 me-10 py-5", { active: tab === "basic" })}  to={"/admin/spy-advanced/influencers/"+influencer_id} onClick={(e) => { onClick("basic"); }}>
                                {t("Basic")}
                            </Link>
                        </li>
                        {/* <li className="nav-item mt-2">
                            <Link className={cx("nav-link text-active-primary ms-0 me-10 py-5", { active: tab === "video_analysis" })}  to={"/admin/spy-advanced/influencers/"+influencer_id} onClick={(e) => { onClick("video_analysis"); }}>
                                {t("Video analysis")}
                            </Link>
                        </li>
                        <li className="nav-item mt-2">
                            <Link className={cx("nav-link text-active-primary ms-0 me-10 py-5", { active: tab === "live_analysis" })}  to={"/admin/spy-advanced/influencers/"+influencer_id} onClick={(e) => { onClick("live_analysis"); }}>
                                {t("Live analysis")}
                            </Link>
                        </li>
                        <li className="nav-item mt-2">
                            <Link className={cx("nav-link text-active-primary ms-0 me-10 py-5", { active: tab === "sale_analysis" })}  to={"/admin/spy-advanced/influencers/"+influencer_id} onClick={(e) => { onClick("sale_analysis"); }}>
                                {t("Sales analysis")}
                            </Link>
                        </li> */}
                    </ul>
                </div>
                {
                    tab === "basic" ? 
                        <Fragment>
                            <Overview detail={detail} overview={overview} sale_overview={sale_overview} follower_trending={follower_trending} digg_trending={digg_trending} video_overview={video_overview} live_overview={live_overview} filter={filter} setFilter={setFilter} />
                            <Followers follower_profile={follower_profile} />
                            <Distributionofproductcategories products_analysis={products_analysis} />
                            <Productrecord products_filters={products_filters} />
                        </Fragment>
                    : ""
                }
            </div>
        </Fragment>
    );
};

export default connect(null, { getInfluencerDetail })(InfluencerDetail);
